import { render, staticRenderFns } from "./CargoList.vue?vue&type=template&id=73929119&scoped=true"
import script from "./CargoList.vue?vue&type=script&lang=js"
export * from "./CargoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73929119",
  null
  
)

export default component.exports